import styled from 'styled-components';

const LoginPageCss = styled.body`
  background: #f6f5f7;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-family: 'Montserrat', sans-serif;
  height: 95vh;
  margin: -20px 0 50px;
  overflow: hidden !important;
`;

export default LoginPageCss;